<nb-card>
    <nb-card-header>
        Strutture
    </nb-card-header>
    <nb-card-body>
        <nb-tabset fullWidth>
            <nb-tab
                [nbSpinner]="!strutture"
                nbSpinnerMessage=""
                tabTitle="Strutture di riferimento"
            >
                <br>
                <strutture-riferimento
                    class="col-12"
                    [comune_corrente_id]="utente?.comune_domicilio ? utente?.comune_domicilio : utente?.comune_residenza"
                ></strutture-riferimento>
            </nb-tab>
            <nb-tab
                [nbSpinner]="!strutture"
                nbSpinnerMessage=""
                tabTitle="Tutte le strutture"
            >
                <br>
                <tutte-strutture
                    class="col-12"
                ></tutte-strutture>
            </nb-tab>
        </nb-tabset>
    </nb-card-body>
</nb-card>
